module.exports = __webpack_public_path__ + "8d7801cf5689b1b9757d27816ac1aeb7.jpg";